import calyx from "calyx/src/calyx";

class Quips {
  constructor(rules) {
    this.grammar = calyx.grammar(rules);
  }

  toString() {
    return this.lookDescription();
  }

  lookDescription() {
    return this.grammar.generate("look").toString();
  }

  bumpDescription() {
    return this.grammar.generate("bump").toString();
  }

  examineDescription() {
    return this.grammar.generate("examine").toString();
  }
}

export default Quips;